import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserPermissionService } from '../../../user/user-permission/user-permission.service';
import { readOnly } from '../../../user/user-permission/user-permission.data';
import { AdvisorData } from 'common';

@UntilDestroy()
@Component({
    selector: 'ifb-business-advisor-widget',
    templateUrl: './business-advisor-widget.component.html',
    styleUrls: ['./business-advisor-widget.component.scss'],
    standalone: false
})
export class BusinessAdvisorWidgetComponent implements OnInit {
  @Input()
  data: AdvisorData;

  @Input()
  teamContactEmail: string;

  @Input()
  canEditAdvisor: boolean;

  @Output()
  edit = new EventEmitter<any>();

  servicingAdvisors = false;

  constructor(private readonly userPermissionService: UserPermissionService) { }

  ngOnInit(): void {
    this.userPermissionService.granted([readOnly('servicing-advisors')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.servicingAdvisors = res);
  }

  editAdvisor(): void {
    this.edit.emit();
  }
}
